var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUser(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "a",
    xmlns: "http://www.w3.org/2000/svg",
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "b",
    d: "M20,22.49853c6.2128-.00093,11.24851-5.03815,11.24758-11.25095C31.24665,5.03478,26.20943-.00093,19.99663,0c-6.21214,.00093-11.24758,5.03712-11.24758,11.24926,.00186,6.21268,5.03826,11.24833,11.25095,11.24926Zm9.99916,2.50021h-4.30386c-3.61397,1.66664-7.77662,1.66664-11.39059,0h-4.30555C4.47743,24.99874,.00093,29.47449,0,34.99621v1.25011c0,2.07124,1.67907,3.75032,3.75032,3.75032H36.24968c2.07124,0,3.75032-1.67907,3.75032-3.75032v-1.25011c-.00093-5.52238-4.47846-9.9984-10.00084-9.99748Z",
    fill: "current"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUser);
export default __webpack_public_path__ + "static/media/user.da45acc20cd5301fdfa0fc03a380f94a.svg";
export { ForwardRef as ReactComponent };